<template>
  <div class="live-show-btn-container">
    <byted-popover
      trigger="hover"
      width="164px"
      popper-class="live-show-btn-popover"
      :placement="popoverPlacement"
      v-if="disable"
    >
      <template slot="body">当前没有正在进行的直播</template>
      <span class="live-show-btn" :class="{disable}" slot="reference">
        <img :src="LiveStaticImg" style="width: 16px"/> 实时大屏
      </span>
    </byted-popover>
    <span class="live-show-btn" @click="onOpenModal" v-else>
      <img :src="LiveDynamicImg" style="align-self: flex-start"/> 实时大屏
    </span>
  </div>
</template>
<script>
import LiveStaticImg from 'Src/static/images/reporter/live_static.svg'
import LiveDynamicImg from 'Src/static/images/reporter/live_dynamic.gif'
import { BytedIconOffScreenOne, BytedIconClose, BytedIconFullScreenTwo } from '@byte-design/vue-icons'
import { isBp } from 'Src/util/tool.js'
const prefix = isBp() ? 'business' : 'ad'

export default {
  name: 'live-show-btn',
  components: {
    BytedIconOffScreenOne,
    BytedIconClose,
    BytedIconFullScreenTwo
  },
  props: {
    onlineRoomList: {
      type: Array,
      default: () => []
    },
    disable: {
      type: Boolean,
      default: true
    },
    analysisView: {
      type: String,
    }
  },
  data () {
    return {
      LiveStaticImg,
      LiveDynamicImg,
      popoverPlacement: isBp() ? 'bottom' : 'top'
    }
  },
  methods: {
    onOpenModal () {
      const advid = window?.GLOBAL_VAR?.advertiser?.id ?? ''
      const URL = `https://${prefix}.oceanengine.com/storm_reporter/pages/live-show?aadvid=${advid}&analysis_view=${this.analysisView}`
      window.open(URL, 'live_show')
    }
  }
}
</script>
<style lang="scss" scoped>
.live-show-btn {
  min-width: 100px;
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(97.22deg, #183cfc -9.71%, #2ef7f7 100%);
  border-radius: 4px;
  height: 34px;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  line-height: 34px;
  cursor: pointer;
  & > img {
    width: 24px;
    margin-right: 3px;
    // align-self: flex-start;
  }
  &.disable {
    opacity: 0.5;
  }
}
/deep/ .live-show-btn-popover {
  color: #666666;
}
</style>
